import { defineStore } from 'pinia'

export const useFreemiumPostsDialogStore = defineStore(
  'freemiumPostsDialog',
  () => {
    const calendarStore = useCalendarStore()

    const showFreemiumPopUpFacebook = ref(false)
    const showFreemiumPopUpInstagram = ref(false)

    const shouldOpen = () => {
      if (
        (calendarStore.spotInfo?.show_freemium_posts_popup_instagram &&
          calendarStore.selectedEntry?.type === 'instagram' &&
          showFreemiumPopUpInstagram.value) ||
        (calendarStore.spotInfo?.show_freemium_posts_popup_facebook &&
          calendarStore.selectedEntry?.type === 'facebook' &&
          showFreemiumPopUpFacebook.value)
      ) {
        window.parent.postMessage(
          {
            action: 'OPEN_FREEMIUM_POSTS_POPUP',
            type: calendarStore.selectedEntry?.type,
          },
          import.meta.env.VITE_SH_URL,
        )
      }
    }

    return {
      shouldOpen,
      showFreemiumPopUpFacebook,
      showFreemiumPopUpInstagram,
    }
  },
)
